export default {
    valid:(value:any)=>{
        // value = value.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/g,"");
        value = value.replace(/[^a-zA-Z0-9\u4e00-\u9fa5\u3002\uff0c\uff1a\uff08\uff09\uff1f\u201c\u201d\u3001\uff01,/$#@%^&*.!:()?_""—-]/g,"");
        return value;
    }
}
